import { PROVIDERSTYPE, PROVIDERSTYPE_SUCCESS, PROVIDERSTYPE_ERROR } from './ProvidersType.actions'

const initialState = {
  chartStructure: [],
  csvStructure: [],
  error: null,
  fetched: false,
  fetching: false
}

/**
 * Provider Type's reducer.
 */
const providersTypeReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case PROVIDERSTYPE: {
      return { ...state, fetching: true }
    }
    case PROVIDERSTYPE_SUCCESS: {
      return {
        ...state,
        chartStructure: payload.chartStructure,
        csvStructure: payload.csvStructure,
        fetched: true,
        fetching: false
      }
    }
    case PROVIDERSTYPE_ERROR: {
      return { ...state, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default providersTypeReducer
